<template>
    <transition-page
        :title="trans('streams.unit_complete.title')"
        :description="trans('streams.unit_complete.description')"
        imgPath="/images/streams/unit_completed.svg"
        :ctaText="trans('streams.unit_complete.cta')"
        :chapterName="streamInfo ? streamInfo.title : ''"
        chapterIcon="star"
        @onCompleted="onCompleted"
    />
</template>
<script>
import TransitionPage from "../../molecules/TransitionPage"
import {mapActions, mapGetters} from "vuex";

export default {
    name: "MissionCompleted",
    components: {TransitionPage},
    data: () => ({
        missionId: null,
    }),
    mounted() {
        this.missionId = this.$route.params.id
        this.getMissionData()
    },
    methods: {
        ...mapActions({
            loadMission: 'streams/loadElement'
        }),
        getMissionData() {
            this.loadMission({...this.$route.params, missionState: 'instruction', elementType: 'mission'});
        },
        onCompleted() {
            this.$router.push({name: 'stream', id: this.$route.params.id})
        }
    },
    computed:{
        ...mapGetters({
            isLoading: 'streams/getLoadingPageState',
            streamInfo: 'streams/getStreamInfo',
        }),
    }
}
</script>
